import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';
import { useNavigate } from 'react-router-dom';

interface PROPS {
  title?: string;
}
export function PAGE__error({ title = 'Error' }: PROPS) {
  const dispatch = use_dispatch();
  const navigate = useNavigate();

  /*
   * EFFECTS
   */
  use_effect(() => void dispatch(LOCAL__workspace_set_is_all_data_loaded(true)));

  /*
   * HTML
   */
  return (
    <div className="cursor-default flex justify-center items-center min-h-screen" id="error-page">
      <div className="flex flex-col gap-5 items-center">
        <h1 className="text-2xl">{title}</h1>
        {/* <h2 className="text-xl">{error?.statusText || error?.message}</h2> */}
        <UI_PRIMITIVE__button variant="outline-on-component" size="sm" onClick={() => navigate(ENUM__page_type.MAIN)}>
          Back to home page
        </UI_PRIMITIVE__button>
      </div>
    </div>
  );
}
